import { HoursSoldReportType } from '@/core/domain/NetReport/WorkOrder/WorkOrder.types';
import { Checkbox, Col, Form, Row } from 'antd';
import { useIntl } from 'react-intl';

export default function ProductiveHoursSoldReportTypeSwitch() {
  const intl = useIntl().formatMessage;

  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const reportType = getFieldValue('typeReport');

        if (reportType === HoursSoldReportType.employee) {
          return (
            <Row gutter={16}>
              <Col>
                <Form.Item name="hideAverageByArea" valuePropName="checked">
                  <Checkbox>
                    {intl({ id: 'productiveHoursSold.checkbox.inhibitArea' })}
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name="showModelAndVersion" valuePropName="checked">
                  <Checkbox>
                    {intl({ id: 'productiveHoursSold.checkbox.viewModel' })}
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
          );
        }
      }}
    </Form.Item>
  );
}
